function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0,0H24V24H0Z",
  "data-name": "Path 3693"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f1f1f1",
  d: "M-1926.259,18.478l-3.5-4.681h-3.44A1.8,1.8,0,0,1-1935,12V7.2a1.8,1.8,0,0,1,1.8-1.8h3.44l3.5-4.681A1.745,1.745,0,0,1-1924.842,0a1.786,1.786,0,0,1,1.81,1.8V17.4a1.786,1.786,0,0,1-1.81,1.8A1.745,1.745,0,0,1-1926.259,18.478Zm-3.5-6.481h.9l.54.722,3.488,4.662V1.819l-3.488,4.662-.54.722h-4.341V12h3.439Z",
  "data-name": "Path 3610",
  transform: "translate(1941 2.4)"
});

function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.22706269.svg";
export { ForwardRef as ReactComponent };